/* eslint-disable */

// object fit functionality
var imageContainer = jQuery(".js-image");
jQuery(document).ready(function () {
    if (!Modernizr.objectfit) {
        imageContainer.each(function () {
            var $container = jQuery(this),
                imgUrl = $container.find("img").attr("data-src");
            if (imgUrl) {
                $container
                    .css("backgroundImage", "url(" + imgUrl + ")")
                    .addClass("compat-object-fit");
            }
        });
    }
});



// WEBPACK FOOTER //
// ./scripts/partials/image-object-fit.js